import { render, staticRenderFns } from "./RoomDecorationAcceptance.vue?vue&type=template&id=4c775cc9"
import script from "./RoomDecorationAcceptance.vue?vue&type=script&lang=js"
export * from "./RoomDecorationAcceptance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports